// @ts-nocheck

import {
  ActiveEditorContext,
  BaseElementWidget,
  RowContext,
  SPI,
  TableEditorMode,
  TableEditorTrigger,
  TableWidget,
  TableWidgetProps,
  VxeTableHelper,
  Widget
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
import { Modal } from 'ant-design-vue';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    widget: 'CustomTableWidget'
  })
)
export class CustomTableWidgetWidget extends TableWidget {
  initialize(props: TableWidgetProps): this {
    super.initialize(props);
    return this;
  }

  @Widget.Method()
  @Widget.Provide()
  protected async rowEditorClosedBefore(context: RowContext) {
    const { id, merchBillName } = context.data;

    if (!merchBillName) return true;

    const hasSameProduct = this.dataSource?.filter((i) => i.id === id && i.merchBillName === merchBillName && i._X_ROW_KEY !== context.key);

    if (hasSameProduct && hasSameProduct?.length > 1) {
      Modal.confirm({
        title: '提示',
        content: '已存在相同的商品清单商品，请重新输入',
        okText: '确定'
      });
      context.data.merchBillName = '';

      return false;
    }

    return true;
  }

  @Widget.Method()
  protected activeEditorBefore(context: ActiveEditorContext): boolean {
    const { field } = context.column;
    let isEnabled = true;
    if (field) {
      const columnWidget = this.getColumnWidgets().find((v) => v.itemData === field);
      if (columnWidget && columnWidget.editable && columnWidget.editorTrigger !== TableEditorTrigger.manual && columnWidget.editorMode === TableEditorMode.cell) {
        const { row, rowIndex, origin } = context;
        isEnabled = columnWidget.cellEditable({
          key: VxeTableHelper.getKey(row),
          data: row,
          index: rowIndex,
          origin
        });
      }
    }
    if (!isEnabled) {
      return false;
    }
    // if (this.tableInstance?.getActiveEditorRecord()) {
    //   return false;
    // }
    return true;
  }

  @Widget.Method()
  @Widget.Provide()
  private async rowEditorClosed(context: RowContext | undefined): Promise<boolean> {
    if (!context) {
      return true;
    }
    if (!this.currentEditorContext?.submit ) {
      await this.rowEditorClosedAfterProcess(context);
      this.lastedCurrentEditorContext = undefined;
      return true;
    }
    let res = await this.rowEditorClosedBefore(context);
    if (!res) {
      return false;
    }
    const data = await this.rowEditorClosedForSubmit(context);
    if (this.inline) {
      if (res && data) {
        this.updateSubviewFieldWidget(context, data);
      }
    } else if (data) {
      try {
        res = await this.rowEditorClosedForUpdate(context, data);
      } catch (e) {
        console.error(e);
        res = false;
      }
    }
    if (res) {
      await this.rowEditorClosedAfterProcess(context);
      this.lastedCurrentEditorContext = undefined;
    }
    return res;
  }
}
